var map = {
	"./blocks/custom/contentImageSlider/block.js": 8143,
	"./blocks/custom/contentTeamCards/block.js": 1171,
	"./blocks/modules/contentPromotionSlider/block.js": 4655,
	"./blocks/sky/callToActionCharlie/block.js": 7809,
	"./blocks/sky/contentBlog/block.js": 1291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9363;